export default "__VITE_ASSET__b0d707e5__"